define(['jquery', 'cookies', 'settings'], function ($, Cookies, Settings) {
	var ReplaceHtml = function() {

		var self = this;
		self.settings = Settings;

		var getCssLink = function($data) {
			var cssLinks = $.grep($data,
				function(elt) {
					return elt.tagName === 'LINK' && elt.rel === 'stylesheet';
				});

			if (cssLinks.length > 0) {
				return $(cssLinks[0]).attr('href');
			}

			return '/assets/dist/css/main_leisure.css';
		};

		var getGTMScript = function($data) {
			var scripts = $.grep($data,
				function(elt) {
					return elt.tagName === 'SCRIPT';
				});

			var scriptStr = '';

			for (var script of scripts) {
				if ($(script).text().indexOf('googletagmanager') > 0) {
					scriptStr += scripts[j].outerHTML;
					break;
				}
			};

			return scriptStr;
		};

		self.replaceHtml = function() {
			var pathName = window.location.pathname;
			var pathNameWithoutStartingSlash = pathName.indexOf('/') === 0
				? pathName.substring(1, pathName.length)
				: pathName;

			var pathNameArr = pathNameWithoutStartingSlash.split('/');
			var firstPathName = '', testFix = '';

			if (pathNameArr.length > 1) {
				if (pathNameArr[0].length > 0) {
					if (pathNameArr[0] === 'testdata') {
						firstPathName = pathNameArr[1];
						testFix = pathNameArr[0] + '/';
					} else {
						firstPathName = pathNameArr[0];
					}
				}
			}

			$.ajax({
				url: '/' + testFix + firstPathName,
				success: function(data) {
					var $ervLoaded = $('body.error-page'),
						$data = $(data),
						$header = $data.find('#header'),
						$footer = $data.find('#footer'),
						cssLink = getCssLink($data);

					if ($ervLoaded.length > 0) {
						setTimeout(function() {
							$ervLoaded.find('#header').html($header);
							$ervLoaded.find('#footer').html($footer);

								var $head = $('head');
								$head.prepend($(getGTMScript($data)));
								$head.find('link[rel="stylesheet"]').attr('href', cssLink);

								$('body').trigger('ervDomChanged');
							},
							100);
					}
				}
			});
		}
	}

	ReplaceHtml.prototype.init = function () {
		var self = this;
		self.replaceHtml();
	};

	return ReplaceHtml;
});